// import quest from "../assets/keys/key_q.png";
import info from "../assets/keys/key_i.png";
import auto from "../assets/keys/key_a.png";
import setting from "../assets/keys/key_s.png";
import double from "../assets/keys/key_d.png";
import fast from "../assets/keys/key_f.png";
import space from "../assets/keys/key_space.png";
import bet from "../assets/keys/key_bet.png";
import esc from "../assets/keys/key_esc.png";
import bonus from "../assets/keys/key_b.png";
import mute from "../assets/keys/key_m.png";
// import { GameConfigs } from "../../lib/globals/GameConfigs";

export default function Shortcuts() {
  const KEYS = [
    {
      key: "A",
      desc: "Turn On/Off Auto Spin",
      visible: true,
      icon: auto,
    },
    {
      key: "Space",
      desc: "Start/Stop Spin",
      visible: true,
      icon: space,
    },
    {
      key: "B",
      desc: "Open/Close Buy Bonus",
      visible: true,
      icon: bonus,
    },
    // {
    //   key: "Q",
    //   desc: "Open/Close Quests",
    //   visible: GameConfigs.hasQuest,
    //   icon: quest,
    // },
    {
      key: "D",
      desc: "Turn On/Off Double Chance",
      visible: true,
      icon: double,
    },
    {
      key: "S",
      desc: "Open/Close Settings",
      visible: true,
      icon: setting,
    },
    {
      key: "I",
      desc: "Open/Close Info",
      visible: true,
      icon: info,
    },
    {
      key: "Esc",
      desc: "Exit Any Popup",
      visible: true,
      icon: esc,
    },
    {
      key: "F",
      desc: "Turn On/Off Fast Spin Mode",
      visible: true,
      icon: fast,
    },
    {
      key: "arrows",
      desc: "Change Bet amount",
      visible: true,
      icon: bet,
    },
    {
      key: "M",
      desc: "Mute/Unmute Sound Effects",
      visible: true,
      icon: mute,
    },
  ];

  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">KEYBOARD SHORTCUTS</div>
        <div className="key_wrapper">
          {KEYS.map(
            (item, id) =>
              item.visible && (
                <div key={id} className="key_content">
                  <div className="key_icon">
                    <img src={item.icon} alt={item.key} />
                  </div>
                  <div className="key_desc">{item.desc}</div>
                </div>
              )
          )}
        </div>
        <div className="description-sm">
          Before using hotkeys like the "CAPS," "SHIFT," and "FN" buttons, make
          sure to turn off any functional keys.
        </div>
      </div>
    </div>
  );
}
